export const normalizeImageName = (
  filename: string,
  scramble = false
): string => {
  const lastDotIndex = filename.lastIndexOf('.')
  const baseName =
    lastDotIndex === -1 ? filename : filename.slice(0, lastDotIndex)

  if (!scramble) return baseName

  return baseName
    .split('')
    .sort(() => Math.random() - 0.5)
    .join('')
}

export const isNonEmptyString = (value: unknown): value is string => {
  return typeof value === 'string' && value.length > 0
}
